const MAX_INT=0x7ffffffe;
const MIN_INT=-0x7ffffffe;

export {MIN_INT, MAX_INT};